module.exports = __webpack_public_path__ + "img/collapse-sidebar.31725fa7.svg";